export default __webpack_public_path__ + "53d74772ea2164f9cba4e9489328eae5.svg";